import React from 'react'

import { defaultIconProps, IconProps } from '@octane/spark'

export function BoatIcon({
    width = defaultIconProps.width,
    height = defaultIconProps.height,
    color = defaultIconProps.color,
}: IconProps) {
    return (
        <svg
            width={width ?? 21}
            height={height ?? 21}
            viewBox="0 0 24 24"
            fill={color ?? 'none'}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.4461 9.48182L15.9094 8.09186C13.6039 6.00664 10.5304 4.99482 7.4441 5.30499L7.28941 5.32053C6.63461 5.38634 6.13596 5.94007 6.13596 6.60139V10.0823C6.06829 10.1584 6.00657 10.2407 5.95177 10.3288L5.51786 11.0265H3.0618C2.49586 11.0265 2.03708 11.4876 2.03708 12.0563V13.601H1.7809C1.07348 13.601 0.5 14.1773 0.5 14.8883V17.4628C0.5 18.1737 1.07348 18.75 1.7809 18.75H11.6128C16.8196 18.75 21.5018 15.5643 23.4356 10.7059C23.669 10.1196 23.2393 9.48182 22.6109 9.48182H17.4461ZM14.8811 9.24003C12.9162 7.46288 10.3031 6.59183 7.67304 6.83469V9.48182H15.1484L14.8811 9.24003ZM3.77475 13.601H3.57416V12.5712H4.55719L3.99199 13.48C3.94518 13.5553 3.86308 13.601 3.77475 13.601ZM7.47245 11.0265C7.38412 11.0265 7.30202 11.0722 7.25521 11.1475L5.29543 14.2987C4.96774 14.8256 4.39305 15.1457 3.77475 15.1457H2.03708V17.2053H11.6128C15.8634 17.2053 19.7163 14.7908 21.6069 11.0265H7.47245Z"
            />
        </svg>
    )
}

export function RVIcon({
    width = defaultIconProps.width,
    height = defaultIconProps.height,
    color = defaultIconProps.color,
}: IconProps) {
    return (
        <svg
            width={width ?? 21}
            height={height ?? 21}
            viewBox="0 0 24 24"
            fill={color ?? 'none'}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.58797 6.85294C3.88026 6.85294 3.30655 7.42905 3.30655 8.13971V10.1985C3.30655 10.9092 3.88026 11.4853 4.58797 11.4853H7.66337C8.37107 11.4853 8.94478 10.9092 8.94478 10.1985V8.13971C8.94478 7.42905 8.37107 6.85294 7.66337 6.85294H4.58797ZM4.84425 9.94118V8.39706H7.40708V9.94118H4.84425Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.2976 17.25C21.104 17.5092 20.8002 17.6618 20.4775 17.6618C20.4775 19.3674 19.1006 20.75 17.4021 20.75C15.7036 20.75 14.3267 19.3674 14.3267 17.6618H10.2262C10.2262 19.3674 8.84929 20.75 7.1508 20.75C5.4523 20.75 4.0754 19.3674 4.0754 17.6618C4.0754 17.4933 4.08884 17.3279 4.11469 17.1668L1.56668 15.8875C1.21938 15.7131 1 15.3566 1 14.9667V4.27941C1 3.71088 1.45897 3.25 2.02513 3.25H18.9597C19.2711 3.25 19.5656 3.39215 19.7602 3.63634L22.8867 7.56082C23.1552 7.89783 22.9163 8.39706 22.4865 8.39706H19.965L22.2902 11.199C22.4437 11.384 22.5278 11.6172 22.5278 11.858V15.2598C22.5278 15.4825 22.4559 15.6993 22.3228 15.8775L21.2976 17.25ZM20.3536 6.85294H12.379C11.8977 6.85294 11.5076 7.24469 11.5076 7.72794V9.68382C11.5076 11.2473 12.7698 12.5147 14.3267 12.5147H20.9901V15.0882L20.2212 16.1176H20.0661C19.5343 15.1946 18.5405 14.5735 17.4021 14.5735C16.2638 14.5735 15.2699 15.1946 14.7382 16.1176H9.81476C9.28301 15.1946 8.28913 14.5735 7.1508 14.5735C6.17052 14.5735 5.29737 15.0341 4.73421 15.7515L2.5377 14.6486V4.79412H18.7133L20.3536 6.85294ZM17.9633 8.39706H13.0453V9.68382C13.0453 10.3945 13.619 10.9706 14.3267 10.9706H20.099L17.9633 8.39706ZM8.6885 17.6618C8.6885 18.5146 8.00005 19.2059 7.1508 19.2059C6.30155 19.2059 5.6131 18.5146 5.6131 17.6618C5.6131 16.809 6.30155 16.1176 7.1508 16.1176C8.00005 16.1176 8.6885 16.809 8.6885 17.6618ZM18.9398 17.6618C18.9398 18.5146 18.2514 19.2059 17.4021 19.2059C16.5529 19.2059 15.8644 18.5146 15.8644 17.6618C15.8644 16.809 16.5529 16.1176 17.4021 16.1176C18.2514 16.1176 18.9398 16.809 18.9398 17.6618Z"
            />
        </svg>
    )
}
